import { t } from 'i18next';

import { ErrorResponseErrorItemCodeTimelineContainer } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeTimelineContainer, string> => ({
  'timeline_container:not_found': t('timelineContainer.notFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'TimelineContainer hittades inte.',
  }),
});
